import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil } from 'rxjs/operators';
import { FuseTranslationLoaderService } from '../../../../../@fuse/services/translation-loader.service';
import { sentry } from '../../../../../sentry';
import { ActionTypeEnum } from '../../../../core/components/fc-list-item/fc-list-item.types';
import { CustomMessagesService } from '../../../../core/errors/custom-messages.service';
import { fetchAllInBatches } from '../../../../core/utils/fetch-all-in-batches';
import { EquipmentsServiceApi } from '../dialog-location/tabs/links/services/equipment/equipment.api';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var DialogLinkEquipmentComponent = /** @class */ (function () {
    function DialogLinkEquipmentComponent(data, fuseTranslationLoaderService, equipmentsServiceApi, matDialogRef, messageService, translateService) {
        this.data = data;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.equipmentsServiceApi = equipmentsServiceApi;
        this.matDialogRef = matDialogRef;
        this.messageService = messageService;
        this.translateService = translateService;
        this.searchTerm = new FormControl();
        this.items = [];
        this.isSaving = false;
        this.isLoading = false;
        this.maxItems = 0;
        this.destroyed$ = new Subject();
        this.equipmentIdsToLink = new Set();
        this.equipmentIdsToUnlink = new Set();
        this.selectedCount = 0;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    DialogLinkEquipmentComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.searchTerm.valueChanges.pipe(takeUntil(this.destroyed$), debounceTime(1000), switchMap(function () { return _this.searchEquipments(); })).subscribe(function () {
                            _this.searchEquipments();
                        });
                        return [4 /*yield*/, this.searchEquipments()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogLinkEquipmentComponent.prototype.searchEquipments = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, , 2, 3]);
                        this.isLoading = true;
                        _a = this;
                        return [4 /*yield*/, fetchAllInBatches(this.equipmentsServiceApi, {
                                where: {
                                    locationId_in: [this.data.locationId],
                                    name_or_number_contains: this.searchTerm.value,
                                }
                            }).then(function (equipments) { return equipments.map(function (equipment) { return _this.toListItem(equipment); }); })];
                    case 1:
                        _a.items = _b.sent();
                        this.selectedCount = this.items.filter(function (item) { return item.selected; }).length;
                        this.maxItems = this.items.length;
                        return [3 /*break*/, 3];
                    case 2:
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DialogLinkEquipmentComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var itemsToUnlink, itemsToLink, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        this.isSaving = false;
                        itemsToUnlink = tslib_1.__spread(this.equipmentIdsToUnlink.values()).map(function (id) {
                            return {
                                equipmentId: id,
                                locationId: _this.data.locationId,
                                locationSectorId: _this.data.locationEnvironmentId ? _this.data.locationSectorId : null,
                                locationEnvironmentId: null
                            };
                        });
                        itemsToLink = tslib_1.__spread(this.equipmentIdsToLink.values()).map(function (id) {
                            return {
                                equipmentId: id,
                                locationId: _this.data.locationId,
                                locationSectorId: _this.data.locationSectorId,
                                locationEnvironmentId: _this.data.locationEnvironmentId
                            };
                        });
                        if (!(itemsToLink.length || itemsToUnlink.length)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.equipmentsServiceApi.linkEquipment({
                                items: tslib_1.__spread(itemsToLink, itemsToUnlink),
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.messageService.success(this.translateService.instant('LINK_EQUIPMENTS_DIALOG.LINK_SUCCESS_MESSAGE'));
                        this.matDialogRef.close({ reload: true });
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        sentry.captureException(error_1);
                        this.messageService.error(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isSaving = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DialogLinkEquipmentComponent.prototype.toListItem = function (equipment) {
        return {
            id: equipment.id,
            text: equipment.name,
            description: equipment.number,
            action: {
                type: ActionTypeEnum.checkbox,
                checked: false,
                disabled: false,
            },
            archived: equipment.archived,
            archivedText: this.translateService.instant('LINK_EQUIPMENTS_DIALOG.ARCHIVED'),
            item: equipment,
            image: equipment.imageUrl,
            selected: this.isSelected(equipment)
        };
    };
    DialogLinkEquipmentComponent.prototype.isSelected = function (equipment) {
        return this.data.locationEnvironmentId
            ? this.data.locationEnvironmentId === (equipment.locationEnvironment && equipment.locationEnvironment.id)
            : this.data.locationSectorId === (equipment.locationSector && equipment.locationSector.id);
    };
    DialogLinkEquipmentComponent.prototype.onSelectedItemChange = function (item) {
        if (item.selected) {
            this.equipmentIdsToLink.add(item.id);
            this.equipmentIdsToUnlink.delete(item.id);
        }
        else {
            this.equipmentIdsToLink.delete(item.id);
            this.equipmentIdsToUnlink.add(item.id);
        }
        this.selectedCount = this.items.filter(function (currentItem) { return currentItem.selected; }).length;
    };
    return DialogLinkEquipmentComponent;
}());
export { DialogLinkEquipmentComponent };
